import React, { Component } from "react";
import $ from "jquery";

class DongDeliveryService extends Component {
  componentDidMount() {
    $(document).ready(function() {
      $('.Subnav').addClass('hide');
      $('.Subnav ul').addClass('hide');
    });
  }

  render() {
    return(
      <div id="box" className="terms">
        <h3 className="title">제1조 (목적)</h3>
        <p>이 약관은 띵동(이하 "운영사")이 운영하는 띵동에서 제공하는 모바일 및 인터넷 관련 서비스와 이를 이용함에 있어 "운영사"와 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.</p>

        <h3>제2조 (정의)</h3>
        <p>① “띵동”란 운영사가 상품 또는 용역 등(일정한 시설을 이용하거나 용역을 제공받을 수 있는 권리를 포함하며, 이하 “상품 등”)을 이용자에게 제공하기 위하여 컴퓨터, 모바일 등 정보통신 설비를 이용하여 상품 등을 거래할 수 있도록 설정한 가상의 영업장을 의미합니다.</p>
        <p>② “이용자”란 띵동에 접속하여 이 약관에 따라 운영사가 제공하는 서비스를 받는 회원을 말합니다.</p>
        <p>③ “회원”이라 함은 띵동에 회원등록을 한 자로서, 계속적으로 띵동에서 제공하는 서비스를 이용할 수 있는 자를 말합니다.</p>
        <p>④ “입점사”라 함은 운영사가 통신판매중개를 위하여 마련한 띵동에 입점하여 실제로 상품 등을 판매하는 자를 말합니다</p>

        <h3>제3조 (약관의 명시와 설명 및 개정)</h3>
        <p>① 운영사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 전자우편주소, 사업자등록번호, 통신판매업신고번호, 개인정보보호책임자 등을 이용자가 쉽게 알 수 있도록 띵동의 초기 서비스 화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결 화면을 통하여 볼 수 있도록 할 수 있습니다.</p>
        <p>② 운영사는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약 철회, 배송 책임, 환불 조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결 화면 또는 팝업 화면 등을 제공 하여 이용자의 확인을 구하여야 합니다.</p>
        <p>③ 운영사는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래 기본법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</p>
        <p>④ 운영사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 띵동의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 운영사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.</p>
        <p>⑤ 개정약관의 효력발생일 이후 이용자가 서비스를 이용하는 경우, 운영사는 이용자가 개정약관에 동의한 것으로 봅니다.</p>
        <p>⑥ 개정 약관조항은 개정 약관의 적용일자 이후에 체결된 계약에 한하여 적용되는 것을 원칙으로 합니다. 다만, 운영사가 지정하는 방식에 따라 회원이 동의를 한 경우에는 개정약관 조항이 적용됩니다.</p>
        <p>⑦ 변경된 약관에 대한 정보를 알지 못해 발생하는 이용자의 피해는 운영사에서 책임지지 않습니다. 단, 회원이 개정 약관에 동의하지 아니할 때에는 회원은 띵동에 대하여 회원의 탈퇴 기타 이용계약을 해지할 수 있습니다.</p>
        <p>⑧ 본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여는 「전자상거래 등에서의 소비자 보호에 관한 법률」, 「약관의 규제에 관한 법률」, 공정거래위원회가 정하는 「전자상거래 등에서의 소비자보호지침」 및 관계 법령 또는 상관례에 따릅니다.</p>

        <h3>제4조 (서비스의 제공 및 변경, 개별적 중단)</h3>
        <div>
          ① 띵동은 다음과 같은 업무를 수행합니다.
          <ul>
            <li>1. 상품 또는 용역에 대한 정보 제공 및 구매 계약의 중개</li>
            <li>2. 구매 계약이 체결된 상품 또는 용역의 배송.배달의 중개</li>
            <li>3. 상품 등의 거래를 위한 통신판매중개서비스 및 이에 수반되는 서비스</li>
            <li>4. 플랫폼 운영 서비스</li>
            <li>5. 기타 운영사가 정하는 업무</li>
          </ul>
        </div>
        <p>② 운영사는 상품 또는 용역의 품질 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 상품 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 상품 또는 용역의 내용 및 제공 일자를 명시하여 현재의 상품 또는 용역의 내용을 게시한 곳에 즉시 공지합니다.</p>
        <p>③ 운영사가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 상품 등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 제8조에서 정한 방법 등으로 즉시 통지합니다.</p>
        <p>④ 전항의 경우 운영사는 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, 운영사가 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.</p>

        <h3>제5조 (서비스의 중지)</h3>
        <div>
          ① 운영사는 다음 각 호 중 어느 하나에 해당하는 사유가 발생하는 경우에는 이용자의 띵동 이용을 제한하거나 중지할 수 있습니다.
          <ul>
            <li>1. 컴퓨터 등 정보통신설비의 보수점검 ∙ 교체 및 고장</li>
            <li>2. 「전기통신사업법」에 규정된 기간통신사업자가 전기통신 서비스를 중지하는 등 통신의 두절</li>
            <li>3. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우</li>
            <li>4. 기타 중대한 사유로 인하여 운영사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우</li>
          </ul>
        </div>
        <p>② 제1항에 의한 서비스 중지의 경우에는 운영사는 제8조에 정한 방법으로 이용자에게 통지합니다.</p>
        <p>③ 운영사는 제1항의 사유로 서비스의 제공이 일시적으로 중지됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 운영사에 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.</p>

        <h3>제6조 (회원가입)</h3>
        <p>① 이용자는 운영사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</p>
        <div>
          ② 운영사는 제1항과 같은 회원가입 신청에 대하여 승낙함으로써 회원가입계약이 성립하며, 다음 각 호 중 어느 하나에 해당하는 이용자의 회원가입 신청에 대해서는 이를 거부할 수 있습니다.
          <ul>
            <li>1. 가입신청자가 본 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 띵동의 회원 재가입 승낙을 얻은 경우에는 예외로 합니다.</li>
            <li>2. 등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
            <li>3. 기타 회원으로 등록하는 것이 띵동의 기술상 현저히 지장이 있다고 판단되는 경우</li>
          </ul>
        </div>
        <p>③ 회원가입계약의 성립시기는 운영사의 승낙이 회원에게 도달한 시점으로 합니다.</p>
        <p>④ 회원은 등록사항에 변경이 있는 경우, 즉시 전자우편 기타 방법으로 운영사에 그 변경사항을 알려야 합니다.</p>
        <p>⑤ 개인정보 보호를 위하여 만 14세 미만 아동의 회원 가입은 제한됩니다.</p>
        <p>⑥ 외국인 또는 해외교민은 운영사가 제공하는 가입조건을 만족할 경우, 가입이 가능합니다.</p>

        <h3>제7조 (회원 탈퇴 및 자격 정지)</h3>
        <p>① 회원은 운영사에 언제든지 탈퇴를 요청할 수 있으며 운영사는 해당 요청을 받는 즉시 회원탈퇴를 처리합니다. 단, 회원 재가입, 임의해지 등을 반복적으로 행함으로써 띵동에서 제공하는 각종 할인쿠폰, 이벤트 혜택 등의 경제상의 이익을 편법적으로 수취하는 것을 방지하기 위하여 운영사는 개인정보처리방침에 따라 해당 회원의 개인정보를 30일 간 보관합니다.</p>
        <div>
          ② 운영사는 회원이 다음 각 호에 해당되는 경우 별도의 통보절차 없이 회원의 자격을 정지할 수 있습니다.
          <ul>
            <li>1. 회원가입 신청이나, 회원정보의 변경 시 허위내용을 작성한 경우</li>
            <li>2. 타인의 명의를 임의로 사용하는 경우</li>
            <li>3. 타인에게 피해를 주거나 기타 미풍양속을 현저히 저해하는 행위를 한 경우</li>
            <li>4. 운영사가 제공하는 정보를 변경 및 수정하는 등 띵동의 정상적인 운영을 고의 또는 과실로 방해하는 행위를 한 경우</li>
            <li>5. 띵동을 이용하여 구입한 상품 등의 대금, 기타 이용에 관련하여 회원이 부담하는 채무를 기일 내에 지급하지 않는 경우</li>
            <li>6. 운영사에 귀속하는 저작권 등 지식재산권을 침해한 경우</li>
            <li>7. 운영사의 명예를 대외적으로 훼손시켰다고 인정되는 경우</li>
            <li>8. 기타 운영사가 정한 회원가입요건이 미비 되었거나 회원으로서의 자격을 지속시키는 것이 부적절하다고 판단되는 경우</li>
            <li>9. 기타 본 약관에 위반한 행위를 한 경우</li>
          </ul>
        </div>
        <p>③ 운영사는 회원 자격을 제한, 정지 시킨 후 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 운영사는 회원 자격을 상실시킬 수 있습니다. 본 경우 회원에게 이를 통지하고, 회원등록 상실 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.</p>
                
        <h3>제8조 (회원에 대한 통지)</h3>
        <p>① 운영사가 회원에 대한 통지를 하는 경우, 회원이 운영사와 미리 약정하여 지정한 전자우편, SMS, 전화, 팩스 등으로 할 수 있습니다.</p>
        <p>② 운영사는 불특정 다수 회원에 대한 통지의 경우 1주일 이상 띵동 게시판에 게시함으로써 개별 통지에 갈음 할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별 통지를 합니다.</p>

        <h3>제9조 (정보의 제공)</h3>
        <p>① 운영사는 서비스 이용에 관한 다양한 정보를 전자우편/ 서신우편/ 문자서비스/ 앱푸쉬 등의 방법으로 회원에게 제공할 수 있으며 회원은 수신을 거부할 수 있습니다.</p>
        <p>② 회원이 전항에 의해 수신을 거부하는 경우, 운영사는 서비스 이용에 필수적으로 요구되는 정보(예: 관련 규정/정책의 변경 등)를 홈페이지에 공시하는 방법으로 정보의 제공을 갈음할 수 있으며, 회원이 수신을 거부하고 홈페이지에 공시된 정보의 제공을 확인하지 아니함에 따라 발생하는 손해에 대해서 운영사는 책임을 부담하지 아니합니다.</p>

        <h3>제10조 (운영사의 의무)</h3>
        <p>① 운영사는 법령과 이 약관이 금지하거나 기타 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다합니다.</p>
        <p>② 운영사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보(신용정보 포함)보호를 위한 보안시스템을 갖추어야 합니다.</p>
        <p>③ 운영사는 회원이 동의하지 않는 영리목적의 광고성 전자우편, 앱푸쉬 등을 발송하지 않습니다.</p>
        <p>④ 운영사는 회원으로부터 제기되는 의견이나 불만이 객관적으로 정당하다고 인정될 경우에는 회원의 불만을 해결하기 위해 노력합니다.</p>

        <h3>제11조 (회원의 의무)</h3>
        <p>① 회원은 이 약관의 규정, 운영사의 이용정책, 이용안내 사항 및 관련 법령 등을 준수하여야 하며, 기타 운영사 업무에 방해되는 행위를 하여서는 안 됩니다.</p>
        <div>
          ② 회원은 다음 각 호의 행위를 하여서는 안 됩니다.
          <ul>
            <li>1. 신청 또는 변경 시 허위내용의 등록</li>
            <li>2. 타인의 정보 도용</li>
            <li>3. 띵동에 게시된 정보의 변경</li>
            <li>4. 운영사가 제공한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시하는 행위</li>
            <li>5. 운영사 또는 기타 제3자의 저작권 등 지식재산권에 대한 침해</li>
            <li>6. 운영사 또는 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li>7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 띵동에 공개 또는 게시하는 행위</li>
          </ul>
        </div>

        <h3>제12조 (회원의 아이디 및 비밀번호에 대한 의무)</h3>
        <p>① 아이디와 비밀번호에 관한 관리책임은 회원 본인에게 있습니다.</p>
        <p>② 회원은 자신의 아이디 및 비밀번호를 제3자에게 제공, 공개하거나 제3자가 이용하도록 해서는 안 됩니다.</p>
        <p>③ 회원이 자신의 아이디 및 비밀번호의 유출 또는 제3자 사용에 대해 인지하고도 비밀번호를 변경하지 않은 경우 또는 이와 같은 사정을 운영사에 통지 하지 않거나 운영사의 조치에 응하지 않은 경우 등 회원이 본 조의 의무를 준수하지 않아 발생하는 모든 손실이나 손해 등 불이익에 대한 책임은 회원에게 있습니다.</p>

        <h3>제13조 (이용자 관리)</h3>
        <div>
          ① 운영사는 이 약관의 본지와 관련 법령 및 상거래의 일반원칙을 위반한 회원에 대하여 다음과 같은 조치를 할 수 있습니다.
          <ul>
            <li>1 운영사가 부가적으로 제공한 혜택의 일부 또는 전부의 회수</li>
            <li>2 특정서비스 이용제한</li>
            <li>3 이용계약의 해지</li>
            <li>4 손해배상의 청구</li>
          </ul>
        </div>
        <p>② 운영사가 전항 각 호에 정한 조치를 할 경우 운영사는 사전에 회원에게 유선 또는 이메일로 통보하나, 회원의 연락이 두절되거나 긴급을 요하는 것과 같이 부득이한 경우 선조치 후 사후 통보할 수 있습니다.</p>
        <p>③ 회원은 본 조에 의한 운영사의 조치에 대하여 항변의 사유가 있는 경우 이에 대하여 항변을 할 수 있습니다.</p>

        <h3>제14조 (운영사와 띵동 연결 사이트 간의 관계)</h3>
        <p>① 상위 웹사이트와 하위 웹사이트가 하이퍼링크(예 : 하이퍼 링크의 대상에는 문자, 그림, 동화상 등이 포함됨) 방식 등으로 연결된 경우, 전자를 연결 웹사이트라고 하고 후자를 피연결 웹사이트라고 합니다.</p>
        <p>② 운영사는 띵동 이외의 피연결 웹사이트에서 취급하는 상품 등에 대하여 보증책임을 지지 않습니다.</p>
        <p>③ 띵동 피연결 웹사이트는 독자적으로 서비스를 운영하는 것으로 운영사는 띵동 연결 사이트와 이용자 간에 행해진 거래에 대하여 어떠한 책임도 지지 않습니다.</p>

        <h3>제15조 (구매신청)</h3>
        <p>띵동 이용자는 띵동 상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 띵동은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다. 단, 회원인 경우 2항 내지 4항의 적용을 제외할 수 있습니다.</p>
        <p>① 상품 등의 검색 및 선택</p>
        <p>② 성명, 주소, 전자우편주소, 전화번호(또는 이동전화번호) 등의 입력</p>
        <p>③ 약관내용, 청약철회권이 제한되는 서비스, 배달료 등의 비용부담과 관련한 내용에 대한 확인</p>
        <p>④ 본 약관에 동의하고 위 3호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)</p>
        <p>⑤ 상품 등의 구매신청 및 이에 관한 확인 또는 운영사의 확인에 대한 동의</p>
        <p>⑥ 결제방법의 선택</p>

        <h3>제16조 (할인쿠폰)</h3>
        <p>① 운영사 또는 입점사는 띵동를 이용하는 회원에게 상품 구매 시 일정액 또는 일정비율을 할인 받을 수 있는 할인쿠폰을 발급할 수 있습니다.</p>
        <p>② 회원은 할인쿠폰을 회원 본인의 구매에 한해서만 사용할 수 있으며, 어떠한 경우에도 이를 타인에게 실질적으로 매매 또는 양도할 수 없습니다.</p>
        <p>③ 할인쿠폰은 품목이나 금액에 따라 사용이 제한될 수 있으며, 유효기간이 지난 후에는 사용할 수 없습니다.</p>
        <p>④ 할인쿠폰을 사용하여 상품을 구입한 후 취소나 반품으로 인하여 환불이 이루어진 경우에는 원칙적으로 할인쿠폰의 재사용이 가능하나 단순변심에 의한 구매취소 등 운영정책으로 정한 일정한 경우에는 재사용이 불가능 할 수 있습니다.</p>

        <h3>제17조 (계약의 성립)</h3>
        <div>
          ① 운영사는 다음 각 호에 해당하는 경우 제15조의 구매신청을 승낙하지 않을 수 있습니다.
          <ul>
            <li>1. 신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
            <li>2. 미성년자가 담배, 주류 등 「청소년보호법」에서 금지하는 상품 등을 구매하는 경우</li>
            <li>3. 기타 구매신청에 승낙하는 것이 띵동 기술상 현저히 지장이 있다고 판단하는 경우</li>
          </ul>
        </div>
        <p>② 운영사의 승낙이 제19조 제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.</p>
        <p>③ 운영사의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매가능 여부, 구매신청의 정정 취소 등에 관한 정보 등을 포함하여야 합니다.</p>
        <p>④ 미성년자가 제15조의 구매신청을 하는 경우, 법정대리인이 구매 금액에 대한 처분을 사전에 동의한 것으로 간주하여 유효한 구매신청으로 판단합니다. 다만, 이미 상품 등이 조리 또는 배달된 경우를 제외하고, 해당 구매신청에 대하여 법정대리인의 동의가 없는 경우, 미성년자 본인 또는 법정대리인은 해당 구매신청을 취소할 수 있습니다.</p>

        <h3>제18조 (이용자의 대금지급방법)</h3>
        <div>
          ① 띵동에서 구매한 상품 등에 대한 대금지급방법은 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 단, 운영사는 이용자의 지급방법에 대하여 상품 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.
          <ul>
            <li>1. 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</li>
            <li>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</li>
            <li>3. 온라인무통장입금</li>
            <li>4. 전자화폐에 의한 결제</li>
            <li>5. 수령 시 대금지급</li>
            <li>6. “띵동”과 계약을 맺었거나 “띵동”이 인정한 상품권에 의한 결제</li>
            <li>7. 기타 전자적 지급 방법에 의한 대금 지급 등</li>
          </ul>
        </div>
        <p>② 이용자가 구매 대금의 결제와 관련하여 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 전적으로 이용자가 부담합니다.</p>
        <p>③ 이용자의 대금 지급에서 신용카드의 경우 5%(부가세별도)의 결제수수료가 적용되며 별도의 수수료 환급정책은 적용되지 않습니다.</p>

        <h3>제19조 (주문성공의 통지 및 구매신청 변경 및 취소)</h3>
        <p>① 운영사는 이용자의 구매신청이 있는 경우, 구매정보가 입점사에 정확히 전달되면 구매자와 입점사 쌍방에 주문 성공 메시지를 전송하여 통지를 합니다.</p>
        <p>② 확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 확인통지를 받은 후 즉시, 직접 띵동 연락처로 구매신청 변경 및 취소를 요청할 수 있습니다. 단, 이용자의 귀책사유로 인한 구매신청의 변경 또는 취소는 입점사의 사정에 따라 받아들여지지 아니할 수 있으며, 이로 인하여 이용자에게 발생하는 손해에 대하여 운영사는 고의 또는 과실이 없는 한 책임을 부담하지 않습니다.</p>
        <p>③ 신용카드에 의한 결제에 따른 지급의 경우에 신용카드회사가 운영사에 신용카드의 연체, 무효 또는 기타 사유로 인한 지급 불능 등을 통지한 경우, 운영사는 회원 등 이용자에게 지급방법의 변경 여부 등에 관한 확인을 할 수 있습니다. 회원 등 이용자가 제공한 주소, 전화번호 또는 전자우편 주소를 통하여 이러한 확인에 이르지 못하는 경우, 운영사는 당해 회원 등 이용자와의 카드결제를 통한 매매계약을 취소할 수 있습니다.</p>

        <h3>제20조 (반품/교환/환불의 적용 배제)</h3>
        <div>
          구매자는 다음 각 호의 경우에는 환불 또는 교환을 요청할 수 없습니다.
          <ul>
            <li>1. 구매자의 귀책사유로 말미암아 상품이 멸실, 훼손된 경우</li>
            <li>2. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우</li>
            <li>3. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품의 가치가 현저히 감소한 경우</li>
            <li>4. 복제가 가능한 상품의 포장을 훼손한 경우</li>
            <li>5. 주문에 따라 개별적으로 생산되는 상품 등 입점사에게 회복할 수 없는 중대한 피해가 예상되는 경우로서 사전에 해당 거래에 대하여 별도로 그 사실을 고지하고 구매자의 서면(전자문서를 포함)에 의한 동의를 받은 경우</li>
            <li>6. 입점사의 귀책사유가 없는 한 조리가 시작된 경우</li>
          </ul>
        </div>

        <h3>제21조 (개인정보보호)</h3>
        <p>① 운영사는 회원의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.</p>
        <p>② 운영사는 회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다.</p>
        <p>③ 운영사는 회원의 개인정보를 수집·이용하는 때에는 당해 회원에게 그 목적을 고지하고 동의를 받습니다.</p>
        <p>④ 운영사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 회원에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.</p>
        <p>⑤ 운영사가 제3항과 제4항에 의해 회원의 동의를 받아야 하는 경우에는 개인정보 관리 책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은 자, 제공목적 및 제공할 정보의 내용) 등 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 에서 규정한 사항을 미리 명시하거나 고지해야 하며 회원은 언제든지 이 동의를 철회할 수 있습니다.</p>
        <p>⑥ 회원은 언제든지 운영사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류 정정을 요구할 수 있으며 운영사는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 회원이 오류의 정정을 요구한 경우에는 운영사는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</p>
        <p>⑦ 운영사는 개인정보 보호를 위하여 회원의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 신용카드, 은행계좌 등을 포함한 회원의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 회원의 손해에 대하여 모든 책임을 집니다.</p>
        <p>⑧ 운영사 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.</p>
        <p>⑨ 운영사는 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에 관한 동의 거절 시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집·이용·제공에 관한 회원의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다.</p>
        <p>⑩ 운영사의 띵동(제2조에서 정한 범위 내) 이외의 연결된 서비스(피연결 웹사이트) 에서는 운영사의 개인정보처리방침이 적용되지 않습니다. 링크된 서비스 및 상품 등을 제공하는 제3자의 개인정보 취급과 관련하여서는 해당 사이버몰 및 제3자의 개인정보처리방침을 확인할 책임이 회원에게 있으며, 운영사는 이에 대하여 책임을 부담하지 않습니다.</p>
        <div>
          ⑪ 운영사는 다음과 같은 경우에 법이 허용하는 범위 내에서 회원의 개인정보를 제3자에게 제공할 수 있습니다.
          <ul>
            <li>1. 수사기관이나 기타 정부기관으로부터 적법한 절차에 따른 정보제공을 요청 받은 경우</li>
            <li>2. 회원이 관련 법령을 위반하는 등의 부정행위를 확인하기 위해 필요한 경우</li>
            <li>3. 입점사 또는 배송업체 등에게 거래 및 배송 등에 필요한 최소한의 회원의 정보(성명, 주소, 전화번호)를 제공하는 경우</li>
            <li>4. 구매가 성사된 때에 그 이행을 위하여 필요한 경우와 구매가 종료된 이후에도 반품, 교환, 환불, 취소 등을 위하여 필요한 경우</li>
            <li>5. 기타 관련 법령에 의해 요구되는 경우</li>
          </ul>
        </div>
        <p>⑫ 기타 본 조에서 정하지 않은 사항은 운영사가 마련한 개인정보처리방침에 따릅니다.</p>

        <h3>제22조 (저작권의 귀속 및 이용제한)</h3>
        <p>① 운영사가 작성한 저작물에 대한 저작권 기타 지식재산권은 운영사에 귀속합니다.</p>
        <p>② 게시물에 대한 권리와 책임은 게시자에게 있으며, 운영사는 게시물에 대한 사용권한을 갖습니다. 이 경우 운영사는 저작권법의 내용을 준수하며, 게시자는 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색 결과 제외, 비공개 등의 조치를 취할 수 있습니다.</p>
        <p>③ 운영사는 띵동 내 게재 이외의 다른 목적으로 사용할 경우에는 저작권법에 따라 저작물의 이용허락을 받아야 하며, 게시물에 대한 게시자를 반드시 명시해야 됩니다.</p>
        <p>④ 이용자는 띵동를 이용함으로써 얻은 정보 중 운영사에게 지식재산권이 귀속된 정보를 운영사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</p>
        <p>⑤ 운영사는 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다.</p>
        <p>⑥ 운영사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다. 단, 운영사의 귀책사유로 인한 것일 때에는 운영사가 정한 바에 따라 이용자가 입은 손해에 대해 조치를 합니다.</p>
        <p>⑦ 운영사는 이용자가 주민등록법을 위반한 명의 도용 및 결제 도용, 저작권법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신 및 해킹, 악성프로그램의 배포 등과 같이 관련 법령을 위반한 경우에는 해당 이용자에 대해 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구 이용정지 시 해당 이용자가 보유 중인 이용할인쿠폰 및 기타 혜택 등도 모두 소멸되며, 운영사는 이에 대해 별도로 보상하지 않습니다.</p>

        <h3>제23조 (금지행위)</h3>
        <div>
          1. 시스템 부정행위
          <ul>
            <li>1) 운영사가 제공하는 서비스 이용방법에 의하지 아니하고 비정상적인 방법으로 서비스를 이용하거나 시스템에 접근하는 행위는 금지됩니다.</li>
            <li>2) 운영사는 시스템 부정행위가 확인된 경우 해당 이용자에 대하여 운영사가 부가적으로 제공한 혜택의 일부 또는 전부의 회수, 특정서비스의 이용제한, 이용계약의 해지 등의 조치를 할 수 있으며 이로 인하여 발생한 손해가 있을 시 이의 배상을 청구할 수 있습니다.</li>
          </ul>
        </div>
        <div>
          2. 결제 부정행위
          <ul>
            <li>1) 타인의 명의나 카드정보, 계좌정보 등을 도용하여 띵동에서 구매서비스를 이용하는 행위는 금지됩니다.</li>
            <li>2) 상품판매 또는 용역제공을 가장하여 자금을 융통하는 것과 같이 여신전문금융업법 등 법령에 의하여 금지된 방법으로 비정상적인 결제를 하는 것은 금지되며, 해당 내용이 확인된 경우 운영사는 이용계약을 해지하거나 당해 거래를 중지시키고 관련기관에 통보할 수 있습니다.</li>
            <li>3) 실제 상품의 배송이 없는 등 상품의 실질적인 구매의사가 없이 구매행위를 하는 것은 금지되며, 해당 내용이 확인 된 경우 운영사는 당해 거래를 취소할 수 있으며 경우에 따라 제재 조치를 취할 수 있습니다.</li>
          </ul>
        </div>
        <div>
          3. 기타 금지 행위
          <ul>
            <li>1) 이용자는 운영사가 제공하는 할인율 등을 이용하여 비정상적인 다수의 거래를 체결시킴으로써 운영사에 손실을 발생시키고 공정한 시장 환경 조성에 방해가 되는 행위 등을 하여서는 아니 되며, 해당 내용이 확인된 경우 운영사는 당해 거래를 취소할 수 있으며 경우에 따라 거래 중지 등의 제재 조치를 가할 수 있습니다.</li>
            <li>2) 운영사는 회원이 제11조에 의거하여 반하는 경우 회원자격을 정지하거나 서비스 제공을 거부 또는 제한할 수 있으며, 그 밖에 법령준수, 타인의 권리보호, 사이트의 안전 확보 등을 위하여 필요한 조치를 취할 수 있습니다.</li>
          </ul>
        </div>

        <h3>제24조 (게시물)</h3>
        <div>
          ① 운영사는 이용자가 작성하는 리뷰 등 게시물(이하 “게시물”이라 함)을 소중하게 생각하며 변조, 훼손, 삭제되지 않도록 최선을 다하여 보호합니다. 다만, 다음 각 호의 어느 하나에 해당하는 게시물에 대해서는 이용자에게 공개적 또는 개별적으로 경고한 후 삭제할 수 있습니다. 단, 상기 경고는 운영사의 판단에 따라 생략할 수 있습니다.
          <ul>
            <li>1. 스팸(spam)성 게시물(예: 행운의 편지, 특정 사이트 또는 입점사의 광고 등)의 경우</li>
            <li>2. 게시물의 내용에 욕설 및 타인 또는 타 입점사에 대한 비방이 과도하게 포함된 경우</li>
            <li>3. 게시물의 내용에 명백한 거짓 사실을 포함하고 있는 경우</li>
            <li>4. 타인을 비방할 목적으로 허위 사실을 유포하여 타인의 명예를 훼손하는 글 또는 타 입점사를 비방하는 게시물의 경우</li>
            <li>5. 게시물이 운영사 또는 제3자의 상표권 또는 저작권 등 지식재산권을 침해하는 경우</li>
            <li>6. 게시물에 첨부된 사진이 부적절한 경우(사진과 상품 등이 일치하지 않거나 게시물의 내용과 상관 없는 사진이 포함된 경우)</li>
            <li>7. 기타 게시판 주제와 관련 없는 내용의 게시물 또는 사회통념상 합리성이 없다고 판단되는 경우</li>
          </ul>
        </div>
        <p>② 운영사는 바람직한 게시판 문화를 활성화하기 위하여 동의 없이 타인 또는 타 입점사의 정보를 게시물에 노출한 경우 또는 게시물에 욕설이 포함된 경우, 문제가 되는 부분을 삭제하거나 기호 등으로 수정할 수 있습니다.</p>
        <p>③ 이용자의 게시물은 운영사가 홍보나 마케팅 등의 목적을 위하여 별도의 대가지급 없이 이용할 수 있습니다.</p>
        <p>④ 다른 주제의 게시판으로 이동 가능한 내용일 경우 해당 게시물에 이동 경로를 밝혀 오해가 없도록 하고 있습니다.</p>
        <p>⑤ 근본적으로 게시물에 관련된 제반 권리와 책임은 작성자 개인에게 있습니다. 특히, 해당 게시물이 제3자의 저작권 등 권리를 침해하는 경우, 침해에 대한 모든 법적 책임은 작성자 부담합니다. 또한 게시물을 통해 자발적으로 공개된 정보는 보호받기 어려우므로 정보 공개 전에 심사숙고 하시기 바랍니다.</p>
        <p>⑥ 회원이 띵동에서 탈퇴하는 경우, 운영사는 회원의 게시물을 회원의 별도의 동의 없이 삭제할 수 있습니다. 또한 운영사는 필요하다고 판단되는 경우, 해당 게시물을 삭제하지 않고 띵동 내에 그대로 게시하거나 사업적 협력관계에 있는 제3자와 공유할 수 있는 권한을 가집니다.</p>

        <h3>제25조 (서비스의 해제 · 해지 · 청약철회)</h3>
        <p>① 회원이 이용 계약을 해지하고자 할 때는 언제든지 띵동 상의 회원 탈퇴 신청을 통해 이용계약 해지를 요청할 수 있습니다. 단, 신규가입 후 일정시간 이내에는 서비스 부정이용 방지 등의 사유로 즉시 탈퇴가 제한될 수 있습니다.</p>
        <p>② 운영사는 회원이 본 약관에서 정한 회원의 의무를 위반한 경우 등 비정상적인 이용 또는 부당한 이용 등을 이유로 회원에게 사전에 고지하고, 계약을 해지할 수 있습니다. 다만, 회원이 현행법 위반 및 고의 또는 과실로 운영사에 손해를 입힌 경우에는 사전 통보 없이 이용계약을 해지할 수 있습니다.</p>
        <p>③ 운영사는 회원이 원활하게 계약을 해지할 수 있도록 계약 체결 시 사용한 방법에 추가하여 계약 해지의 수단으로서 아래와 같은 방법을 제공합니다.</p>
        <p>- 고객센터 전화: 1800-9991</p>

        <h3>제26조 (손해배상)</h3>
        <p>① 운영사가 법률 및 본 약관을 위반한 행위로 이용자에게 손해가 발생한 경우 이용자는 운영사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 운영사는 고의, 과실이 없음을 입증하지 못 하는 경우 책임을 면할 수 없습니다.</p>
        <p>② 운영사는 이용자와 입점사 간의 상품 등 구매계약에 대해 중개 서비스를 제공할 뿐이므로, 이용자가 입점사로부터 구매하신 상품 등의 품질이나 입점사의 신뢰도에 대해서는 보증하지 않습니다.</p>
        <p>③ 운영사는 이용자가 입점사로부터 구매한 상품 등에 대해 보증하거나 별도의 책임을 지지 않으며, 상품 등과 관련한 일체의 책임은 입점사에게 있습니다.</p>
        <p>④ 운영사에 손해배상을 청구하는 경우에는 청구사유, 청구금액 및 산출근거를 기재하여 서면으로 제출하여야 합니다.</p>

        <h3>제27조 (고객센터)</h3>
        <p>① 운영사는 회원 상호간 또는 회원과 제3자 사이의 불만처리 및 분쟁조정을 하기 위하여 고객센터를 운영합니다.</p>
        <p>② 운영사는 고객센터를 통하여 회원으로부터 제기되는 불만사항 및 의견이 정당하다고 판단되는 경우 이를 신속하게 처리합니다.</p>
        <p>③ 고객센터의 분쟁조정시 회원은 신의칙에 따라 성실히 응하여야 합니다.</p>

        <h3>제28조 (면책조항)</h3>
        <p>① 운영사는 전시, 사변 등 국가 비상사태 및 천재지변 기타 이에 준하는 불가항력인 상황으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.</p>
        <p>② 운영사는 기간통신사업자 등 전기통신사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우에 대해서 책임이 면제됩니다.</p>
        <p>③ 운영사는 사전에 공지된 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우에 대해서 책임이 면제됩니다.</p>
        <p>④ 운영사는 이용자의 귀책사유로 인한 서비스 이용의 중지, 장애 또는 손해가 발생한 경우에 대해서 책임이 없습니다.</p>
        <p>⑤ 운영사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여, 책임이 없습니다.</p>
        <p>⑥ 운영사는 이용자가 서비스를 이용하면서 얻은 정보나 자료로 인한 손해 및 타 이용자의 귀책사유 인해 손해가 발생한 경우에 대하여 책임을 지지 않습니다.</p>
        <p>⑦ 운영사는 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우 또는 회원이 회원정보 또는 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우에 책임을 부담하지 않습니다.</p>
        <p>⑧ 운영사는 이용자가 서비스에 게재한 게시물 등 각종 정보의 신뢰도, 정확성 등 내용에 대하여 책임을 부담하지 않습니다.</p>
        <p>⑨ 운영사는 사용 기간이 경과한 할인쿠폰 등에 대하여 사용권을 보장하지 않습니다.</p>

        <h3>제29조 (분쟁해결)</h3>
        <p>① 운영사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치 ∙ 운영합니다.</p>
        <p>② 운영사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 줍니다.</p>
        <p>③ 운영사와 이용자간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시 ∙ 도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.</p>
        <p>④ 운영사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보분쟁조정위원회에 조정을 신청하거나 방송통신위원회에 조정을 신청할 수 있습니다.</p>

        <h3>제30조 (재판권 및 준거법)</h3>
        <p>① 운영사와 이용자간에 발생한 전자상거래 분쟁에 관한 소송은 민사소송법상의 관할법원에 따릅니다.</p>
        <p>② 운영사와 이용자 간의 분쟁은 본 약관 및 대한민국법을 적용합니다.</p>
      </div>
    )
  }
}

export { DongDeliveryService }